import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HelpersService } from './services/helpers.service';
import { HttpClientModule } from '@angular/common/http';
import { OrdersService } from './services/orders.service';
import { AuthService } from './services/auth.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import player from 'lottie-web';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedRoutingModule } from './shared-routing.module';
import { Error404Component } from './components/error404/error404.component';
import { TranslateModule } from '@ngx-translate/core';
import { FlowErrorComponent } from './components/flow-error/flow-error.component';
import { GenericErrorComponent } from './components/generic-error/generic-error.component';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { MonthsToYears } from '../../pipes/monthsToYears.pipe';
import { CalculateDiscount } from '../../pipes/calculateDiscount.pipe';
import { BackofficeService } from './services/backoffice.service';
import { LoginErrorComponent } from './components/login-error/login-error.component';
import { DashboardService } from './services/dashboard.service';
import { OtpFormComponent } from './components/otp-form/otp-form.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SecurityQuestionsFormComponent } from './components/security-questions-form/security-questions-form.component';
import { MatInputModule } from '@angular/material/input';
import { AuthGuard } from '../../guards/auth.guard';
import { HelpDialogComponent } from './components/help-dialog/help-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalPdfComponent } from './components/modal-pdf/modal-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { OtpMonoFormComponent } from './components/otp-mono-form/otp-mono-form.component';
import { DisabledAddressInputComponent } from './components/disabled-address-input/disabled-address-input.component';
import { PrefixSelectComponent } from './components/prefix-select/prefix-select.component';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';
import { DashboardHomeButtonsComponent } from './components/dashboard-home-buttons/dashboard-home-buttons.component';
import { ContractPaymentCardComponent } from './components/contract-payment-card/contract-payment-card.component';
import { MatRadioModule } from '@angular/material/radio';
import { ContractSelectionFormComponent } from './components/contract-selection-form/contract-selection-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SubscriptionRenewalModal } from './components/subscription-renewal-modal/subscription-renewal-modal.component';
import { ImpressumModal } from './components/impressum-dialog/impressum-dialog.component';
import { LegacyMigrationService } from './services/legacy-migration.service';
import { RenewalErrorDialogComponent } from './components/renewal-error-dialog/renewal-error-dialog.component';
import { ConsentsModal } from './components/consents-dialog/consents-dialog.component';
import { TyOnboardingModalComponent } from './components/ty-onboarding-modal/ty-onboarding-modal.component';
import { AuthOtpFormComponent } from './components/auth-otp-form/auth-otp-form.component';
import { HeaderFixedComponent } from './components/header fixed/header-fixed.component';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderFixedComponent,
    FooterComponent,
    SpinnerComponent,
    Error404Component,
    FlowErrorComponent,
    GenericErrorComponent,
    SessionExpiredComponent,
    LoginErrorComponent,
    WizardComponent,
    MonthsToYears,
    CalculateDiscount,
    AuthOtpFormComponent,
    OtpFormComponent,
    OtpMonoFormComponent,
    SecurityQuestionsFormComponent,
    HelpDialogComponent,
    DisabledAddressInputComponent,
    PrefixSelectComponent,
    AuthErrorComponent,
    ModalPdfComponent,
    DashboardHomeButtonsComponent,
    ContractPaymentCardComponent,
    ContractSelectionFormComponent,
    SubscriptionRenewalModal,
    ImpressumModal,
    ConsentsModal,
    TyOnboardingModalComponent,
    RenewalErrorDialogComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatSelectModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedRoutingModule,
    MatDialogModule,
    PdfViewerModule,
    NgbModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatTooltipModule,
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    MatSelectModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedRoutingModule,
    MatDialogModule,
    PdfViewerModule,
    NgbModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatTooltipModule,
    HeaderComponent,
    HeaderFixedComponent,
    FooterComponent,
    SpinnerComponent,
    Error404Component,
    FlowErrorComponent,
    GenericErrorComponent,
    SessionExpiredComponent,
    LoginErrorComponent,
    WizardComponent,
    MonthsToYears,
    CalculateDiscount,
    AuthOtpFormComponent,
    OtpFormComponent,
    OtpMonoFormComponent,
    SecurityQuestionsFormComponent,
    HelpDialogComponent,
    DisabledAddressInputComponent,
    PrefixSelectComponent,
    AuthErrorComponent,
    ModalPdfComponent,
    DashboardHomeButtonsComponent,
    ContractPaymentCardComponent,
    ContractSelectionFormComponent,
    SubscriptionRenewalModal,
    ImpressumModal,
    ConsentsModal,
    TyOnboardingModalComponent,
    RenewalErrorDialogComponent,
  ],
  providers: [
    HelpersService,
    OrdersService,
    AuthService,
    BackofficeService,
    DashboardService,
    LegacyMigrationService,
    AuthGuard,
    CurrencyPipe,
  ],
})
export class SharedModule {}
